import { REGIONS } from "model/Region";
import { useMultiFilter } from "./Filters";

// todo - create generic that takes a selector??
// todo - extract the adding of "All" to generic useFilter
export const useMultiRegionFilter = () => {
  return useMultiFilter([...REGIONS]);
};
